import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import variable from '../style/variable';

export interface ITable {
    columns: string[];
    rows: ITableRow[];
}

export interface ITableRow {
    label: string;
    values: ITableValue[];
    isBold?: boolean;
}

interface ITableValue {
    value?: number | boolean | string;
    check?: boolean;
}

export interface IMyTableProps {
    data: ITable;
}

const MyTable = (props: IMyTableProps) => {
    const { t } = useTranslation();
    return (
        <TableContainer>
            <Table aria-label='geometry-table'>
                <TableHead variant='green'>
                    <TableRow>
                        {props.data.columns.map((x, i) => (
                            <TableCell key={`${x}_${i}`}>{x}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.data.rows.map((x, u) => (
                        <TableRow key={x.label} variant={u % 2 === 0 ? 'greyLight' : 'white'}>
                            <TableCell component='th' sx={{ paddingLeft: '16px' }} scope='row' variant='result'>
                                {x.label}
                            </TableCell>
                            {x.values.map((x, i) => {
                                let error = typeof x.value == 'boolean' ? x.value : typeof x.check == 'boolean' ? x.check : undefined;
                                return (
                                    <TableCell key={i} align='left' variant='result'>
                                        <Stack
                                            sx={{
                                                border: error == undefined ? '' : error ? `2px solid ${variable.turquoise_500}` : `2px solid ${variable.red_800}`,
                                                backgroundColor: error == undefined ? '' : error ? variable.green_100 : variable.red_100,
                                            }}
                                            height={'100%'}
                                            direction={'row'}
                                            gap={1}>
                                            <Stack height={'100%'} flex={1} justifyContent={'center'} paddingLeft={'16px'}>
                                                {x.value == undefined ? (
                                                    '-'
                                                ) : typeof x.value == 'boolean' ? (
                                                    x.value ? (
                                                        <CheckIcon style={{ color: variable.turquoise_500 }} />
                                                    ) : (
                                                        <CloseIcon style={{ color: variable.red_800 }} />
                                                    )
                                                ) : (
                                                    x.value
                                                )}
                                            </Stack>
                                            <Stack
                                                height={'100%'}
                                                flex={1}
                                                paddingX={'16px'}
                                                alignItems={'center'}
                                                sx={{
                                                    display: x.check == undefined ? 'none' : '',
                                                    borderLeft: x.check ? `2px solid ${variable.turquoise_600}` : `2px solid ${variable.red_800}`,
                                                }}
                                                direction={'row'}
                                                justifyContent={'space-between'}>
                                                <Stack style={{ color: variable.turquoise_600 }}>{t('check')}</Stack>
                                                {x.check ? <CheckIcon style={{ color: variable.turquoise_500 }} /> : <CloseIcon style={{ color: variable.red_800 }} />}
                                            </Stack>
                                        </Stack>
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MyTable;
